import { render, staticRenderFns } from "./moderation-list-item.vue?vue&type=template&id=3cdfa67a&scoped=true&"
import script from "./moderation-list-item.vue?vue&type=script&lang=js&"
export * from "./moderation-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdfa67a",
  null
  
)

export default component.exports